<script>

import ShopCard from "@/components/CatalogView/ShopCard.vue";
import {usePriceItemStore} from "@/store/price-items";
import {computed} from "vue";

export default {
  name: "ShopList",
  components: {ShopCard},
  props: ['categories', 'caption'],
  setup(props) {
    const priceItemStore = usePriceItemStore()

    const topItems = computed(() => {
      const categories = priceItemStore.items.filter(
          category =>  inCategory(category.category_id)
      )
      return categories
          .flatMap(category => category.price_list_items) //беру вложенные price_list_items
          .sort(() => Math.random() - 0.5)
          .slice(0, 5); // Беру верхние 5
    });

    function inCategory(category_id) {
        const found = props.categories.find(category => category_id === category)
        return !!found;
    }

    return {topItems}
  }
}
</script>

<template>
  <div class="shopList" v-if="topItems?.length > 0">
    <span class="shopList__header">{{caption}}</span>
    <ShopCard
        v-for="item in topItems"
        :key="item.id"
        :item="item"
    >
    </ShopCard>
  </div>
</template>

<style scoped lang="scss">
.shopList {
  display: inline-flex;
  flex-direction: column;
  width: 256px;
  max-width: 100%;
  gap: 20px;
  text-align: left;

  @include respond-to('lg') { width: 100%; flex-direction: row; flex-wrap: wrap; }
  @include respond-to('md') { width: 100%; }

  &__header {
    color: var(--cd-text-muted);
    @include respond-to('lg') { width: 100%; }
  }
}
</style>
